import React from "react";
import { FaLock } from "react-icons/fa"; // Lock icon for closed session
import "./ClosedSession.css";

const ClosedSession = () => {
  return (
    <div className="closed-session">
      <FaLock className="closed-icon" />
      <p className="closed-text">This session is closed.</p>
    </div>
  );
};

export default ClosedSession;
